import { useState } from 'react'
import { formatDistanceToNow } from 'date-fns'
import { Bell } from 'lucide-react'
import { useNotifications } from '@/hooks/useNotifications'
import { Button } from '@/components/ui/button'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'

export function PortalNotificationBell() {
  const { notifications, unreadCount, markAsRead, markAllAsRead } = useNotifications()
  const [open, setOpen] = useState(false)

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="sm" className="relative p-2 h-8 w-8">
          <Bell className="w-4 h-4 text-muted-foreground" />
          {unreadCount > 0 && (
            <span className="absolute -top-0.5 -right-0.5 w-4 h-4 bg-accent text-white text-[9px] font-bold rounded-full flex items-center justify-center leading-none">
              {unreadCount > 9 ? '9+' : unreadCount}
            </span>
          )}
        </Button>
      </PopoverTrigger>

      <PopoverContent className="w-80 p-0" align="end">
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <span className="font-semibold text-sm">Notifications</span>
          {unreadCount > 0 && (
            <button onClick={() => markAllAsRead()} className="text-xs text-accent hover:underline">
              Mark all read
            </button>
          )}
        </div>

        <div className="max-h-80 overflow-y-auto divide-y divide-border">
          {notifications.length === 0 ? (
            <p className="text-justify text-sm text-muted-foreground text-center py-8">No notifications</p>
          ) : (
            notifications.slice(0, 10).map(n => (
              <button
                key={n.id}
                type="button"
                onClick={() => { markAsRead(n.id); setOpen(false) }}
                className={`w-full text-left px-4 py-3 hover:bg-muted/50 transition-colors ${!n.is_read ? 'bg-accent/5' : ''}`}
              >
                <div className="flex items-start gap-2">
                  {!n.is_read && (
                    <span className="w-1.5 h-1.5 rounded-full bg-accent mt-1.5 shrink-0" />
                  )}
                  <div className={!n.is_read ? '' : 'pl-3.5'}>
                    <p className="text-justify text-xs font-semibold text-foreground">{n.title}</p>
                    <p className="text-justify text-xs text-muted-foreground mt-0.5 line-clamp-2">{n.message}</p>
                    <p className="text-justify text-[10px] text-muted-foreground/70 mt-1">
                      {formatDistanceToNow(new Date(n.created_at), { addSuffix: true })}
                    </p>
                  </div>
                </div>
              </button>
            ))
          )}
        </div>
      </PopoverContent>
    </Popover>
  )
}
